import { render, staticRenderFns } from "./gameResultSportsbookExportFull.vue?vue&type=template&id=f0a31508&lang=pug"
import script from "./gameResultSportsbookExportFull.vue?vue&type=script&lang=js"
export * from "./gameResultSportsbookExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports